// Konfigurationen ligger separat från msGraph.js så att MSAL-biblioteket
// (~67 kB) inte hamnar i huvudbundeln. Själva klienten laddas först när
// Outlook-kopplingen faktiskt används.
export const MS_CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID || '';
export const MS_TENANT_ID = process.env.REACT_APP_MS_TENANT_ID || 'organizations';

// Sant när appregistreringen i Entra ID är på plats. När den saknas faller
// UI:t tillbaka på .ics-export.
export function isGraphConfigured() {
  return !!MS_CLIENT_ID;
}
